export default "__VITE_ASSET__C7xOSc$J__"